<div *ngIf="hasBonus && !showDetails" class="row collapse bonus-list-wrapper" [class.selected]="donation.bonus !== null">
	<div class="column">
		<label [class.error]="!form.controls['bonus'].valid && form.controls['bonus'].touched" [innerHTML]="(form.controls['bonus'].valid || !form.controls['bonus'].touched? 'bonus.label' : 'bonus.error') | translate"></label>
	</div>
	<div class="column {{columClasses}}" *ngFor="let item of bonus">
		<div class="bonus-wrapper" [class.selected]="item.slug === donation.bonus">
			<img (click)="selectBonus(item)" *ngIf="item.image" [src]="item.image" [alt]="item.textkeys['name'] | translate" alt="" aria-hidden="true">
			<h3 (click)="onShowDetails($event, item)"><span [innerHTML]="item.textkeys['name'] | translate"></span><i class="twingle-info" tabindex="0" (click)="onShowDetails($event, item)" (keydown.space)="onShowDetails($event, item)"></i></h3>

			<radio [form]="form" [(model)]="donation.bonus" [value]="item.slug" [required]="true" name="bonus" [label]="(donation.bonus === item.slug? 'bonus.button.chosen' : 'bonus.button.choose') | translate"></radio>
		</div>
	</div>
	<div class="column small-12 ">
		<div class="bonus-wrapper none" [class.selected]="bonusNoneOption === donation.bonus">
			<checkbox-button class="no-error" [value]="bonusNoneOption" [(model)]="donation.bonus" [uncheckedValue]="null" [form]="form" name="bonus" [label]="'bonus.button.choose.none' | translate"></checkbox-button>
		</div>
	</div>
</div>
<div *ngIf="showDetails">
	<div class="row bonus-details-wrapper">
		<div class="column small-4 medium-6" *ngIf="showDetails.image">
			<img [src]="showDetails.image" [alt]="showDetails.textkeys['name'] | translate">
		</div>
		<div class="column small-8 medium-6">
			<h3 [innerHTML]="showDetails.textkeys['name'] | translate"></h3>
			<p [innerHTML]="showDetails.textkeys['description'] | translate"></p>
			<button class="button" (click)="selectBonus(showDetails)" [innerHTML]="'bonus.button.choose' | translate"></button>
		</div>
	</div>
</div>

